import gql from "graphql-tag";

export default gql`
  query PayRatioHistory($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on AmericanCompanyIssuer {
        _id
        payRatioHistory {
          additionalDescription
          payRatioCompensationMethod
          payRatio
          medianEmployeePay
          ceoPay
          currency
          reportSource
          reportDate
          fiscalYear
        }
      }
    }
  }
`;
